import { FC } from 'react';
import { SearchTrigger, Text, TextTabScrollable } from '@croquiscom-pvt/zds';

import { BannerGroup, ShopInfo, TextCategoryList } from '@domains/storehome-common';

import { StorehomeMainComponentList } from '../../component-list/containers/StorehomeMainComponentList';
import { DefaultMainBannerContainer } from '../../main-banner/containers/DefaultMainBannerContainer';
import { DefaultShopInformationContainer } from '../../shop-information/containers/DefaultShopInformationContainer';
import { Divider, ScrollWrap, SearchTriggerWrap, TextTabWrapper } from '../components/Main.styled';
import { useMainService } from '../services/useMainService';

export interface StoreHomeViewProps {
  shop_info: ShopInfo;
  is_header_solid?: boolean;
  banner_group: BannerGroup | null;
  category_list: TextCategoryList[];
  is_preview?: boolean;
}

export const DefaultMainContainer: FC<React.PropsWithChildren<StoreHomeViewProps>> = ({
  shop_info,
  banner_group,
  category_list,
  is_preview,
}) => {
  const {
    params,
    shop_id,
    shop_name,
    applied_banner_group,
    categories,
    component_list_props,
    exists_banner,
    onParamsChange,
    fetchNextPage,
    handleCategoryClick,
    handleImpressionCategory,
    handleSearchClick,
  } = useMainService({ shop_info, banner_group, is_preview, category_list });
  return (
    <ScrollWrap>
      <TextTabWrapper>
        <TextTabScrollable
          defaultValue={null}
          items={categories}
          onChange={handleCategoryClick}
          hideBorderBottom
          onImpression={handleImpressionCategory}
          impressionMode='once'
          fullWidth={false}
        />
      </TextTabWrapper>
      <DefaultMainBannerContainer shop_id={shop_id} banner_group={applied_banner_group} is_preview={is_preview} />
      <DefaultShopInformationContainer shop_info={shop_info} is_cover_view={exists_banner} />
      <Divider />
      {shop_info.show_search_button && (
        <SearchTriggerWrap>
          <SearchTrigger onClick={handleSearchClick} color='textSecondary' borderColor='borderStrong'>
            <Text color='textStrong' as='span' variant='Body_15_Multiline_Bold'>
              {shop_name}
            </Text>{' '}
            내에서 검색해보세요.
          </SearchTrigger>
        </SearchTriggerWrap>
      )}
      <StorehomeMainComponentList
        type='store'
        params={params}
        {...component_list_props}
        onFetchNextPage={fetchNextPage}
        onParamsChange={onParamsChange}
      />
    </ScrollWrap>
  );
};
